import FullPageLoader from "./FullPageLoader.jsx";
export default FullPageLoader;